import { gql } from "@apollo/client";

export const POBLAR_CONEXIONES_PENDIENTES_FACTURAR = gql`
mutation poblarConexionesPendientesAFacturar($mes: Int!, $anio: Int!, $fechaHasta: CustomDateTime!) {
    poblarConexionesPendientesAFacturar(mes: $mes, anio: $anio, fechaHasta: $fechaHasta) {
        success
        valorEsperado
        error
    }
}`;